/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/job_notes_junction-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/job_notes_junction-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/job_notes_junction-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-job_notes_junction-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/job_notes_junction.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-29T23:22:39.711Z
 * Source config: config/entities/job_notes_junction-entity-config.ts
 * Public fields: 15/15 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const JobNotesJunctionSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  job_id: Type.String({ format: "uuid" }), // job_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  trig_job_name: Type.Union([Type.String(), Type.Null()]), // trig_job_name field - trigger-populated denormalized field
  trig_job_number: Type.Union([Type.String(), Type.Null()]), // trig_job_number field - trigger-populated denormalized field
  trig_job_status_name: Type.Union([Type.String(), Type.Null()]), // trig_job_status_name field - trigger-populated denormalized field
  trig_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // trig_organization_id field - trigger-populated denormalized field
  trig_note_content: Type.Union([Type.String(), Type.Null()]), // trig_note_content field - trigger-populated denormalized field
  trig_note_title: Type.Union([Type.String(), Type.Null()]), // trig_note_title field - trigger-populated denormalized field
  trig_note_created_by: Type.Union([Type.String(), Type.Null()]), // trig_note_created_by field - trigger-populated denormalized field
  trig_note_is_internal: Type.Union([Type.Boolean(), Type.Null()]), // trig_note_is_internal field - trigger-populated denormalized field
  trig_note_type: Type.Union([Type.String(), Type.Null()]), // trig_note_type field - trigger-populated denormalized field
});

export const CreateJobNotesJunctionSchema = Type.Object({
  job_id: Type.String({ format: "uuid" }), // job_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

export const UpdateJobNotesJunctionSchema = Type.Object({
  job_id: Type.String({ format: "uuid" }), // job_id field
  note_id: Type.String({ format: "uuid" }), // note_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type JobNotesJunctionRow = Static<typeof JobNotesJunctionSchema>;
export type JobNotesJunctionInsert = Static<typeof CreateJobNotesJunctionSchema>;
export type JobNotesJunctionUpdate = Static<typeof UpdateJobNotesJunctionSchema>;

// Legacy type aliases for backward compatibility
export type JobNotesJunction = JobNotesJunctionRow;
export type CreateJobNotesJunction = JobNotesJunctionInsert;
export type UpdateJobNotesJunction = Static<typeof UpdateJobNotesJunctionSchema>;

// Field configuration metadata
export const JobNotesJunctionFieldConfig = {
  filterable: ['id', 'job_id', 'note_id', 'trig_organization_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['job_id', 'note_id'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'trig_job_name', 'trig_job_number', 'trig_job_status_name', 'trig_organization_id', 'trig_note_content', 'trig_note_title', 'trig_note_created_by', 'trig_note_is_internal', 'trig_note_type'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface JobNotesJunctionQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface JobNotesJunctionResponse {
  data: JobNotesJunction[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleJobNotesJunctionResponse {
  data: JobNotesJunction | null;
  error: Error | null;
}
